var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "soli-round",
      on: {
        click: function ($event) {
          _vm.$inertia.visit(_vm.route("help-articles.show", _vm.card.id))
        },
      },
    },
    [
      _c("v-card-title", { staticClass: "primary--text" }, [
        _vm._v(" " + _vm._s(_vm.card.title) + " "),
      ]),
      _vm._v(" "),
      _c("v-card-subtitle", { attrs: { title: _vm.card.updated_at } }, [
        _vm._v("Last updated " + _vm._s(_vm.card.updated_at_display)),
      ]),
      _vm._v(" "),
      _c("v-card-text", [_vm._v(_vm._s(_vm.card.excerpt))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }